export default __webpack_public_path__ + "static/media/location.78a64fec.webp";